import React from 'react';
import styled from 'styled-components';
import { media, sizes } from 'styles/breakpoints';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import bannerImage from 'styles/images/bannerImage.jpg';
import bannerImageMobile from 'styles/images/bannerImageMobile.jpg';

const Image = styled.img`
  display: block;
  margin: 0 auto;
  width: 100%;

  ${media.small`
    width: 80%;
  `};
`;

export default function Logo() {
  return (
    <Link to="/">
      <MediaQuery maxWidth={sizes.small}>
        {matches => {
          return matches ? (
            <Image src={bannerImageMobile} />
          ) : (
            <Image src={bannerImage} />
          );
        }}
      </MediaQuery>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js